// Dev token storage (05-admin §2.2).
//
// In production the console is fronted by Cloudflare Access (Zero Trust): the
// Access JWT is delivered as a cookie/`Cf-Access-Jwt-Assertion` header by the
// edge, so the browser sends it automatically (we use `credentials: "include"`).
// There is no in-app login form in prod.
//
// For LOCAL development the API is usually run without the Access perimeter, so
// we let the operator paste a bearer token (a moderator/admin access JWT) that
// is attached as `Authorization: Bearer <token>`. This is dev-only.
const KEY = "shortdrama.admin.devtoken";

export function saveDevToken(token: string): void {
  localStorage.setItem(KEY, token.trim());
}

export function loadDevToken(): string | null {
  const raw = localStorage.getItem(KEY);
  return raw && raw.length > 0 ? raw : null;
}

export function clearDevToken(): void {
  localStorage.removeItem(KEY);
}

export function hasDevToken(): boolean {
  return loadDevToken() !== null;
}
